import { Redirect, RouteComponentProps } from '@reach/router';
import React, { FC } from 'react';
import Loader from '../../components/loader/Loader';
import OpenPageLayout from '../../components/pagelayout/OpenPageLayout';
import { useUserContext } from '../../lib/UserContext';

export const ThreadsRedirect: FC<RouteComponentProps> = () => {
  const { loading, loggedInUser } = useUserContext();

  if (loading) {
    return (
      <OpenPageLayout>
        <Loader />
      </OpenPageLayout>
    );
  } else if (loggedInUser) {
    return <Redirect to={`/${loggedInUser.user.patientId}/meldinger`} noThrow />;
  } else {
    return <Redirect to={`/login?returnto=${encodeURIComponent('/meldinger')}`} noThrow />;
  }
};
